import Vue from 'vue';
import Schedule from '../views/Schedule';
import VueRouter from 'vue-router';

Vue.use(VueRouter);

const routes = [
	{
		path: '/',
		name: 'schedule',
		component: Schedule,
		meta: {
			title: 'Schedule',
		},
	},
	{
		path: '/overview',
		name: 'overview',
		component: () => import(/* webpackChunkName: "Overview" */ '../views/Overview.vue'),
		meta: {
			title: 'Overview',
		},
	},
];

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes,

	scrollBehavior(to, from, savedPosition) {
		// Default scroll position will be 0, 0 unless overridden by a saved position
		const position = {
			x: 0,
			y: 0,
		};

		// Override default with saved position (if it exists)
		if (savedPosition) {
			position.x = savedPosition.x;
			position.y = savedPosition.y;
		}

		// Listen for scrollBeforeEnter event and set scroll position
		/*eslint-disable */
		return new Promise(resolve => {
			this.app.$root.$once('scrollBeforeEnter', () => {
				resolve(position);
			});
		});
		/* eslint-enable */
	},
});
export default router;
